import TagManager from "react-gtm-module";

export function initializeGTM() {
  try {
    if (process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID) {
      TagManager.initialize({
        gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID,
      });
      console.log('Google Tag Manager initialize');
    }
  } catch (error) {
    console.log('GTM initialization error:', error);
  }
}

export function gtmStartEvent(email) {
  try {
    if (process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID) {
      const tagManagerArgs = {
        dataLayer: {
          event: 'start_pw',
          pw_user_email: email,
        },
      };

      TagManager.dataLayer(tagManagerArgs);
      console.log('Google Tag Manager Start Event');
    }
  } catch (error) {
    console.log('error with tag manager');
    console.log(error);
  }
}

export function gtmCheckoutPublicEvent(route) {
  try {
    if (process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID) {
      const tagManagerArgs = {
        dataLayer: {
          event: 'checkout_' + route,
        },
      };

      TagManager.dataLayer(tagManagerArgs);
      console.log('Google Tag Manager Checkout Event');
    }
  } catch (error) {
    console.log('error with tag manager');
    console.log(error);
  }
}